import React from 'react';

const DownloadComponent = ({children, file}) => {
  return <a href={file} rel="noopener noreferrer" target="_blank" className="mr-5 text-size-h4 font-weight-bold" download>{children}</a>
}

export default DownloadComponent;